import { useConfirm as uC } from "primevue";
import { ConfirmationOptions } from "primevue/confirmationoptions";

export const defaultConfirmOptions = {
    message: "Are you sure you want to delete this?",
    header: "Confirmation",
    icon: "la la-exclamation-triangle",
    rejectProps: {
        label: "Cancel",
        severity: "secondary",
        outlined: true,
    },
    acceptProps: {
        label: "Delete",
        severity: "danger",
    },
};

export function useConfirm() {
    const confirm = uC();

    return {
        require(options: ConfirmationOptions) {
            confirm.require({
                ...defaultConfirmOptions,
                ...options,
            });
        },
        close: confirm.close,
    };
}
